module.exports = __webpack_public_path__ + "4.3.2/img/design_X2_2.3f04f6f9.png";